import fontOptions from './font-options.esm.js';

var fontColorOptionList = Object.keys(fontOptions.color);
var fontLeadingOptionList = Object.keys(fontOptions.leading);
var fontSizeOptionList = Object.keys(fontOptions.size);
var fontTrackingOptionList = Object.keys(fontOptions.tracking);
var fontWeightOptionList = Object.keys(fontOptions.weight);
var fontFamilyOptionList = Object.keys(fontOptions.fontFamily);
var textEllipsisOptionList = Object.keys(fontOptions.ellipsis);

export { fontColorOptionList, fontFamilyOptionList, fontLeadingOptionList, fontSizeOptionList, fontTrackingOptionList, fontWeightOptionList, textEllipsisOptionList };
//# sourceMappingURL=types.esm.js.map
